import React, { useEffect, useState } from "react";
import { Menu, X } from "lucide-react";

const NAV = [
  { href: "#services", label: "خدمات" },
  { href: "#platforms", label: "پلتفرم‌ها" },
  { href: "#pricing", label: "تعرفه‌ها" },
  { href: "#revenue", label: "درآمد موزیک" },
  { href: "#faq", label: "سوالات متداول" },
];

export default function Header() {
  const [scrolled, setScrolled] = useState(false);
  const [open, setOpen] = useState(false);

  useEffect(() => {
    const onScroll = () => setScrolled(window.scrollY > 12);
    window.addEventListener("scroll", onScroll);
    return () => window.removeEventListener("scroll", onScroll);
  }, []);

  const scrollTo = (id) => {
    setOpen(false);
    const el = document.querySelector(id);
    if (el) el.scrollIntoView({ behavior: "smooth", block: "start" });
  };

  return (
    <header
      data-testid="site-header"
      className={`fixed top-0 inset-x-0 z-50 transition-all duration-300 ${
        scrolled ? "py-3" : "py-5"
      }`}
    >
      <div className="max-w-7xl mx-auto px-4 md:px-8">
        <div
          className={`flex items-center justify-between glass rounded-full px-4 md:px-6 py-2.5 ${
            scrolled ? "shadow-[0_8px_40px_rgba(0,0,0,0.35)]" : ""
          }`}
        >
          <a href="#top" className="flex items-center" data-testid="brand-logo">
            <img
              src="https://customer-assets.emergentagent.com/job_persian-music-pay/artifacts/a7snz7bp_f2677fb0-9319-4ac7-b749-1aff4f634497.png"
              alt="YouberMusic"
              className="h-10 md:h-12 w-auto select-none mix-blend-lighten"
              draggable="false"
            />
          </a>

          <nav className="hidden md:flex items-center gap-1">
            {NAV.map((n) => (
              <button
                key={n.href}
                onClick={() => scrollTo(n.href)}
                data-testid={`nav-${n.href.slice(1)}`}
                className="px-4 py-2 text-sm text-slate-300 hover:text-white rounded-full hover:bg-white/5 transition-colors"
              >
                {n.label}
              </button>
            ))}
          </nav>

          <div className="flex items-center gap-2">
            <button
              data-testid="header-cta"
              onClick={() => scrollTo("#register")}
              className="btn-primary text-xs md:text-sm !py-2 !px-3 md:!py-2.5 md:!px-4 whitespace-nowrap"
            >
              ثبت درخواست
            </button>
            <button
              data-testid="mobile-menu-toggle"
              onClick={() => setOpen(!open)}
              className="md:hidden p-2 rounded-full glass"
              aria-label="منو"
            >
              {open ? <X className="w-5 h-5" /> : <Menu className="w-5 h-5" />}
            </button>
          </div>
        </div>

        {open && (
          <div className="md:hidden mt-2 glass rounded-3xl p-4 space-y-1" data-testid="mobile-menu">
            {NAV.map((n) => (
              <button
                key={n.href}
                onClick={() => scrollTo(n.href)}
                className="w-full text-right px-4 py-3 text-slate-200 hover:bg-white/5 rounded-2xl transition"
              >
                {n.label}
              </button>
            ))}
            <button
              onClick={() => scrollTo("#register")}
              className="w-full btn-primary justify-center mt-2"
              data-testid="mobile-cta"
            >
              ثبت درخواست
            </button>
          </div>
        )}
      </div>
    </header>
  );
}
